// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><%21--%21 Font Awesome Pro 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license %28Commercial License%29 Copyright 2024 Fonticons, Inc. --><path d=\"M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BottomSheet */
.wildidea {
  --sheet-background: var(--card-paper1-background);
  --sheet-header-background: var(--card-paper1-header-background);
  --sheet-header-border-bottom: #dbdbde;
  --sheet-text-color: var(--card-paper1-text-color);
}

/* Button */
.wildidea {
  --button-font-size: 1.1em;
  --button-border-radius: 12px;
  --button-padding-y: 0.6em;
  --button-padding-x: 0.8em;
  --button-transition-duration: 170ms;

  --button-rest-shadow: var(--shadow-0);
  --button-rest-transform: perspective(100px) translate(0, 0);
  --button-active-shadow: var(--shadow-0);
  --button-active-transform: perspective(100px) translate3d(0, 1px, -1px);

  --button-elevated-rest-shadow: var(--shadow-2);
  --button-elevated-rest-transform: perspective(100px) translate3d(0, -2px, 1px);
  --button-elevated-active-shadow: var(--shadow-1);
  --button-elevated-active-transform: perspective(100px) translate3d(0, 1px, -1px);

  --button-focus-outline: var(--default-focus-outline);
  --button-focus-outline-offset: 3px;

  --button-paper1-color-main: var(--color-paper-1);
  --button-paper1-color-text: var(--color-paper-text);

  --button-paper2-color-main: var(--color-paper-2);
  --button-paper2-color-text: var(--color-paper-text);

  --button-inverse-color-main: var(--color-inverse);
  --button-inverse-color-text: var(--color-inverse-text);

  --button-accent-color-main: var(--color-yellow-1);
  --button-accent-color-text: white;

  --button-success-color-main: var(--color-green-1);
  --button-success-color-text: white;

  --button-destructive-color-main: var(--color-red-2);
  --button-destructive-color-text: white;

  --button-info-color-main: var(--color-blue-2);
  --button-info-color-text: white;
}

/* Card */
.wildidea {
  --card-padding-y: 1.5em;
  --card-padding-x: 1.5em;
  --card-heading-margin: 1em;
  --card-elevated-shadow: var(--shadow-3);
  --card-border-radius: 6px;

  --card-paper1-background: var(--color-paper-1);
  --card-paper1-border: none;
  --card-paper1-text-color: var(--color-paper-text);
  --card-paper1-header-background: var(--color-grey-2);

  --card-paper2-background: var(--color-paper-2);
  --card-paper2-border: none;
  --card-paper2-text-color: var(--color-paper-text);
  --card-paper2-header-background: var(--color-grey-1);

  --card-inverse-background: var(--color-inverse);
  --card-inverse-border: none;
  --card-inverse-text-color: var(--color-inverse-text);

  --card-accent-background: var(--gradient-purple-1);
  --card-accent-border: none;
  --card-accent-text-color: white;

  --card-info-background: var(--gradient-blue-1);
  --card-info-border: none;
  --card-info-text-color: white;

  --card-success-border: none;
  --card-success-text-color: white;
  --card-success-background: var(--color-green-1);

  --card-warn-border: none;
  --card-warn-text-color: black;
  --card-warn-background: var(--color-yellow-1);

  --card-error-border: none;
  --card-error-text-color: white;
  --card-error-background: var(--gradient-red-1);

  --card-header-font-weight: normal;
}

.wildidea {
  --card-paper1-background: var(--color-grey-7);
  --card-paper1-text-color: white;

  --card-paper2-background: var(--color-grey-7);
  --card-paper2-text-color: white;

  --card-inverse-background: var(--color-grey-1);
  --card-inverse-text-color: black;
}

/* Checkbox */
.wildidea {
  --checkbox-margin: 0.7em 0 0.3em;
  --checkbox-padding-inside: 0.7em;
  --checkbox-invalid-focus-outline-color: var(--color-red-2);
}

/* ControlsRow */
.wildidea {
  --controls-row-gap: 0.6em;
  --controls-row-justify-content: flex-start;
}

/* Fieldset */
.wildidea {
  --fieldset-margin: 0 0 1em;
  --fieldset-padding: 1em;
  --fieldset-border: 1px solid var(--color-grey-2);
  --fieldset-border-radius: 6px;
  --fieldset-elevated-background: white;
  --fieldset-elevated-box-shadow: var(--formField-box-shadow);
  --fieldset-elevated-transform: var(--formField-transform);
  --fieldset-legend-gap: 0.4em;
  --fieldset-legend-background: white;
  --fieldset-legend-border-radius: 8px;
  --fieldset-legend-padding: 0.3em 0.5em 0.2em;
  --fieldset-legend-margin: -2.8em 0 0.2em;
  --fieldset-legend-font-size: var(--formField-font-size);
  --fieldset-legend-font-weight: normal;
  --fieldset-legend-border-bottom: 1px solid black;
}

/* FileInputArea */
.wildidea {
  --file-input-area-color: var(--color-grey-2);
  --file-input-area-margin: 0 0 1em 0;
}

/* FormField */
.wildidea {
  --formField-margin: 0.6em 0 0.3em;
  --formField-font-size: 1em;
  --formField-text-align: start;
  --formField-box-shadow: var(--shadow-1);
  --formField-transform: translate(0, 0);
  --formField-border-color: none;
  --formField-loading-xerox-color: transparent;
  --formField-border-radius: 12px;
  --formField-padding-y: 0.3em;
  --formField-padding-x: 0.9em;
  --formField-background-color: white;
  --formField-transition-duration: var(--default-transition-duration);
  --formField-transition-timing: ease;

  --formField-label-font-family: inherit;
  --formField-label-font-weight: inherit;
  --formField-label-color: var(--color-yellow-1);
  --formField-label-ems: 1.1;

  --formField-placeholder-color: var(--color-grey-5);

  --formField-input-height: 1.4em;
  --formField-input-font-family: inherit;
  --formField-input-font-size: 1em;
  --formField-input-font-weight: inherit;
  --formField-input-color: black;
  --formField-input-trigger-padding-right: 1.2em;

  --formField-focus-outline: var(--default-focus-outline);
  --formField-focus-outline-offset-to: 2px;
  --formField-focus-outline-offset-from: 8px;

  --formField-invalid-border-color: var(--color-red-2);
  --formField-invalid-label-color: var(--color-red-2);

  --formField-tooltip-box-shadow: var(--shadow-2);
  --formField-errormessage-color: white;
  --formField-errormessage-background-color: var(--color-red-2);
  --formField-errormessage-border-color: white;

  --formField-helpmessage-color: var(--color-grey-3);
  --formField-helpmessage-font-size: 0.9em;

  --formField-select-trigger-content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --formField-select-trigger-padding: 0.25em 0 0 0;
}

/* Modal */
.wildidea {
  --modal-sm-margin-top: 15vh;
  --modal-md-margin-top: 10vh;
  --modal-lg-margin-top: 6vh;
  --modal-margin-bottom: 10vh;
  --modal-backdrop-background: rgba(0, 0, 0, 0.3);
  --modal-backdrop-transition-duration: var(--default-transition-duration);
  --modal-backdrop-transition-timing: var(--default-transition-timing);
  --modal-backdrop-filter: blur(3px);
  --modal-header-font-family: var(--subheading-font);
  --modal-header-font-size: 1.2em;
  --modal-header-font-weight: normal;
  --modal-header-padding: 1.3em;
  --modal-header-gap: 1.3em;
  --modal-touch-action: pan-x pan-y;
}
@media screen and (min-width: 430px) {
.wildidea {
    --modal-header-font-size: 1.2em;
}
  }

/* Pill */
.wildidea {
  --pill-font-size: 0.75em;
  --pill-font-weight: 500;
  --pill-border-radius: 8px;
  --pill-padding: 0.25em 0.5em;
  --pill-children-space-between: 0.4em;

  --pill-paper1-background: var(--color-paper-1);
  --pill-paper1-color: var(--color-paper-text);
  --pill-paper2-background: var(--color-paper-2);
  --pill-paper2-color: var(--color-paper-text);
  --pill-inverse-background: var(--color-inverse);
  --pill-inverse-color: var(--color-inverse-text);
  --pill-info-background: var(--color-blue-1);
  --pill-info-color: white;
  --pill-success-background: var(--color-green-1);
  --pill-success-color: white;
  --pill-warn-background: var(--color-yellow-1);
  --pill-warn-color: black;
  --pill-error-background: var(--color-red-2);
  --pill-error-color: white;
}

/* RadioInput */
.wildidea {
  --radio-input-invalid-focus-outline-color: var(--color-red-2);
}

/* Small */
.wildidea {
  --small-font-size: 0.9em;
  --small-font-weight: lighter;
  --small-text-decoration: line-through;
  --small-color: var(--color-grey-3);
}

/* Strong */
.wildidea {
  --strong-font-size: 1.2em;
  --strong-font-weight: bold;
  --strong-font-style: italic;
  --strong-font-variant: small-caps;
  --strong-font-family: var(--logo-font);
  --strong-text-decoration: underline;
  --strong-text-underline-offset: 0.1em;
  --strong-color: var(--color-blue-1);
}

/* SubmitButton */
.wildidea {
  --submit-button-animation-duration-ms: 1000;
}

/* Toaster */
.wildidea {
  --toaster-left: 0;
  --toaster-right: 0;
  --toaster-margin-x: auto;
  --toaster-margin-bottom: 1rem;

  --toast-margin-y: 0;
  --toast-width: 30em;
  --toast-max-width: calc(100% - 2em);
  --toast-font-size: 1em;
  --toast-dismiss-button-font-size: 0.9em;

  --toast-progress-height: 0.2em;
  --toast-progress-value-background: white;
}
@media screen and (min-width: 430px) {
.wildidea {
    --toaster-right: auto;
    --toaster-margin-x: 2em;
}
  }

/* Tooltip */
.wildidea {
  --tooltip-border-size: 2px;
  --tooltip-border-radius: 4px;
  --tooltip-transition-duration: var(--default-transition-duration);
  --tooltip-transition-timing: ease;
  --tooltip-min-width: 6em;
  --tooltip-max-width: 100vw;
  --tooltip-padding: 0.6em 1em;

  --tooltip-trigger-offset: 0.5em;
  --tooltip-arrow-size: 7px;

  --tooltip-paper1-background: var(--color-paper-1);
  --tooltip-paper1-color: var(--color-paper-text);

  --tooltip-paper2-background: var(--color-paper-2);
  --tooltip-paper2-color: var(--color-paper-text);

  --tooltip-inverse-background: var(--color-inverse);
  --tooltip-inverse-color: var(--color-inverse-text);

  --tooltip-info-background: var(--gradient-blue-1);
  --tooltip-info-color: white;

  --tooltip-accent-background: var(--gradient-purple-1);
  --tooltip-accent-color: white;

  --tooltip-success-background: var(--color-green-1);
  --tooltip-success-color: white;

  --tooltip-warn-background: var(--color-yellow-1);
  --tooltip-warn-color: black;

  --tooltip-error-background: var(--gradient-red-1);
  --tooltip-error-color: white;

  --tooltip-box-shadow: var(--shadow-2);
  --tooltip-elevated-box-shadow: var(--shadow-3);
}

/* Typeahead */
.wildidea {
  --typeahead-menu-listitem-highlighted-background: var(--color-grey-5);
  --typeahead-menu-border: var(--color-grey-4);
  --typeahead-menu-listitem-border-top: var(--color-grey-4);
}
`, "",{"version":3,"sources":["webpack://./src/theme/components.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,iDAAiD;EACjD,+DAA+D;EAC/D,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;EACzB,mCAAmC;;EAEnC,qCAAqC;EACrC,2DAA2D;EAC3D,uCAAuC;EACvC,uEAAuE;;EAEvE,8CAA8C;EAC9C,8EAA8E;EAC9E,gDAAgD;EAChD,gFAAgF;;EAEhF,oDAAoD;EACpD,kCAAkC;;EAElC,gDAAgD;EAChD,mDAAmD;;EAEnD,gDAAgD;EAChD,mDAAmD;;EAEnD,iDAAiD;EACjD,sDAAsD;;EAEtD,iDAAiD;EACjD,iCAAiC;;EAEjC,iDAAiD;EACjD,kCAAkC;;EAElC,mDAAmD;EACnD,sCAAsC;;EAEtC,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA,SAAS;AACT;EACE,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,uCAAuC;EACvC,yBAAyB;;EAEzB,8CAA8C;EAC9C,0BAA0B;EAC1B,iDAAiD;EACjD,oDAAoD;;EAEpD,8CAA8C;EAC9C,0BAA0B;EAC1B,iDAAiD;EACjD,oDAAoD;;EAEpD,+CAA+C;EAC/C,2BAA2B;EAC3B,oDAAoD;;EAEpD,kDAAkD;EAClD,0BAA0B;EAC1B,+BAA+B;;EAE/B,8CAA8C;EAC9C,wBAAwB;EACxB,6BAA6B;;EAE7B,2BAA2B;EAC3B,gCAAgC;EAChC,+CAA+C;;EAE/C,wBAAwB;EACxB,6BAA6B;EAC7B,6CAA6C;;EAE7C,yBAAyB;EACzB,8BAA8B;EAC9B,8CAA8C;;EAE9C,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;;EAE/B,6CAA6C;EAC7C,+BAA+B;;EAE/B,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA,aAAa;AACb;EACE,gCAAgC;EAChC,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA,aAAa;AACb;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,gDAAgD;EAChD,6BAA6B;EAC7B,qCAAqC;EACrC,2DAA2D;EAC3D,yDAAyD;EACzD,4BAA4B;EAC5B,mCAAmC;EACnC,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,uDAAuD;EACvD,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA,kBAAkB;AAClB;EACE,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA,cAAc;AACd;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,6BAA6B;EAC7B,uCAAuC;EACvC,sCAAsC;EACtC,8BAA8B;EAC9B,4CAA4C;EAC5C,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;EAC5B,mCAAmC;EACnC,mEAAmE;EACnE,mCAAmC;;EAEnC,sCAAsC;EACtC,sCAAsC;EACtC,8CAA8C;EAC9C,0BAA0B;;EAE1B,kDAAkD;;EAElD,+BAA+B;EAC/B,sCAAsC;EACtC,gCAAgC;EAChC,sCAAsC;EACtC,8BAA8B;EAC9B,8CAA8C;;EAE9C,uDAAuD;EACvD,wCAAwC;EACxC,0CAA0C;;EAE1C,oDAAoD;EACpD,mDAAmD;;EAEnD,+CAA+C;EAC/C,qCAAqC;EACrC,6DAA6D;EAC7D,4CAA4C;;EAE5C,kDAAkD;EAClD,wCAAwC;;EAExC,2EAAqd;EACrd,gDAAgD;AAClD;;AAEA,UAAU;AACV;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,+CAA+C;EAC/C,wEAAwE;EACxE,oEAAoE;EACpE,kCAAkC;EAClC,kDAAkD;EAClD,+BAA+B;EAC/B,kCAAkC;EAClC,6BAA6B;EAC7B,yBAAyB;EACzB,iCAAiC;AAKnC;AAHE;AAhBF;IAiBI,+BAA+B;AAEnC;EADE;;AAGF,SAAS;AACT;EACE,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;;EAEpC,8CAA8C;EAC9C,4CAA4C;EAC5C,8CAA8C;EAC9C,4CAA4C;EAC5C,+CAA+C;EAC/C,+CAA+C;EAC/C,2CAA2C;EAC3C,wBAAwB;EACxB,+CAA+C;EAC/C,2BAA2B;EAC3B,6CAA6C;EAC7C,wBAAwB;EACxB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,6DAA6D;AAC/D;;AAEA,UAAU;AACV;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,sCAAsC;EACtC,mCAAmC;EACnC,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,2CAA2C;AAC7C;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;;EAE7B,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,sBAAsB;EACtB,uCAAuC;;EAEvC,8BAA8B;EAC9B,wCAAwC;AAM1C;AAJE;AAfF;IAgBI,qBAAqB;IACrB,uBAAuB;AAE3B;EADE;;AAGF,YAAY;AACZ;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,iEAAiE;EACjE,iCAAiC;EACjC,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;;EAE5B,+BAA+B;EAC/B,yBAAyB;;EAEzB,iDAAiD;EACjD,+CAA+C;;EAE/C,iDAAiD;EACjD,+CAA+C;;EAE/C,kDAAkD;EAClD,kDAAkD;;EAElD,iDAAiD;EACjD,2BAA2B;;EAE3B,qDAAqD;EACrD,6BAA6B;;EAE7B,kDAAkD;EAClD,8BAA8B;;EAE9B,gDAAgD;EAChD,2BAA2B;;EAE3B,iDAAiD;EACjD,4BAA4B;;EAE5B,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA,cAAc;AACd;EACE,qEAAqE;EACrE,4CAA4C;EAC5C,yDAAyD;AAC3D","sourcesContent":["/* BottomSheet */\n.wildidea {\n  --sheet-background: var(--card-paper1-background);\n  --sheet-header-background: var(--card-paper1-header-background);\n  --sheet-header-border-bottom: #dbdbde;\n  --sheet-text-color: var(--card-paper1-text-color);\n}\n\n/* Button */\n.wildidea {\n  --button-font-size: 1.1em;\n  --button-border-radius: 12px;\n  --button-padding-y: 0.6em;\n  --button-padding-x: 0.8em;\n  --button-transition-duration: 170ms;\n\n  --button-rest-shadow: var(--shadow-0);\n  --button-rest-transform: perspective(100px) translate(0, 0);\n  --button-active-shadow: var(--shadow-0);\n  --button-active-transform: perspective(100px) translate3d(0, 1px, -1px);\n\n  --button-elevated-rest-shadow: var(--shadow-2);\n  --button-elevated-rest-transform: perspective(100px) translate3d(0, -2px, 1px);\n  --button-elevated-active-shadow: var(--shadow-1);\n  --button-elevated-active-transform: perspective(100px) translate3d(0, 1px, -1px);\n\n  --button-focus-outline: var(--default-focus-outline);\n  --button-focus-outline-offset: 3px;\n\n  --button-paper1-color-main: var(--color-paper-1);\n  --button-paper1-color-text: var(--color-paper-text);\n\n  --button-paper2-color-main: var(--color-paper-2);\n  --button-paper2-color-text: var(--color-paper-text);\n\n  --button-inverse-color-main: var(--color-inverse);\n  --button-inverse-color-text: var(--color-inverse-text);\n\n  --button-accent-color-main: var(--color-yellow-1);\n  --button-accent-color-text: white;\n\n  --button-success-color-main: var(--color-green-1);\n  --button-success-color-text: white;\n\n  --button-destructive-color-main: var(--color-red-2);\n  --button-destructive-color-text: white;\n\n  --button-info-color-main: var(--color-blue-2);\n  --button-info-color-text: white;\n}\n\n/* Card */\n.wildidea {\n  --card-padding-y: 1.5em;\n  --card-padding-x: 1.5em;\n  --card-heading-margin: 1em;\n  --card-elevated-shadow: var(--shadow-3);\n  --card-border-radius: 6px;\n\n  --card-paper1-background: var(--color-paper-1);\n  --card-paper1-border: none;\n  --card-paper1-text-color: var(--color-paper-text);\n  --card-paper1-header-background: var(--color-grey-2);\n\n  --card-paper2-background: var(--color-paper-2);\n  --card-paper2-border: none;\n  --card-paper2-text-color: var(--color-paper-text);\n  --card-paper2-header-background: var(--color-grey-1);\n\n  --card-inverse-background: var(--color-inverse);\n  --card-inverse-border: none;\n  --card-inverse-text-color: var(--color-inverse-text);\n\n  --card-accent-background: var(--gradient-purple-1);\n  --card-accent-border: none;\n  --card-accent-text-color: white;\n\n  --card-info-background: var(--gradient-blue-1);\n  --card-info-border: none;\n  --card-info-text-color: white;\n\n  --card-success-border: none;\n  --card-success-text-color: white;\n  --card-success-background: var(--color-green-1);\n\n  --card-warn-border: none;\n  --card-warn-text-color: black;\n  --card-warn-background: var(--color-yellow-1);\n\n  --card-error-border: none;\n  --card-error-text-color: white;\n  --card-error-background: var(--gradient-red-1);\n\n  --card-header-font-weight: normal;\n}\n\n.wildidea {\n  --card-paper1-background: var(--color-grey-7);\n  --card-paper1-text-color: white;\n\n  --card-paper2-background: var(--color-grey-7);\n  --card-paper2-text-color: white;\n\n  --card-inverse-background: var(--color-grey-1);\n  --card-inverse-text-color: black;\n}\n\n/* Checkbox */\n.wildidea {\n  --checkbox-margin: 0.7em 0 0.3em;\n  --checkbox-padding-inside: 0.7em;\n  --checkbox-invalid-focus-outline-color: var(--color-red-2);\n}\n\n/* ControlsRow */\n.wildidea {\n  --controls-row-gap: 0.6em;\n  --controls-row-justify-content: flex-start;\n}\n\n/* Fieldset */\n.wildidea {\n  --fieldset-margin: 0 0 1em;\n  --fieldset-padding: 1em;\n  --fieldset-border: 1px solid var(--color-grey-2);\n  --fieldset-border-radius: 6px;\n  --fieldset-elevated-background: white;\n  --fieldset-elevated-box-shadow: var(--formField-box-shadow);\n  --fieldset-elevated-transform: var(--formField-transform);\n  --fieldset-legend-gap: 0.4em;\n  --fieldset-legend-background: white;\n  --fieldset-legend-border-radius: 8px;\n  --fieldset-legend-padding: 0.3em 0.5em 0.2em;\n  --fieldset-legend-margin: -2.8em 0 0.2em;\n  --fieldset-legend-font-size: var(--formField-font-size);\n  --fieldset-legend-font-weight: normal;\n  --fieldset-legend-border-bottom: 1px solid black;\n}\n\n/* FileInputArea */\n.wildidea {\n  --file-input-area-color: var(--color-grey-2);\n  --file-input-area-margin: 0 0 1em 0;\n}\n\n/* FormField */\n.wildidea {\n  --formField-margin: 0.6em 0 0.3em;\n  --formField-font-size: 1em;\n  --formField-text-align: start;\n  --formField-box-shadow: var(--shadow-1);\n  --formField-transform: translate(0, 0);\n  --formField-border-color: none;\n  --formField-loading-xerox-color: transparent;\n  --formField-border-radius: 12px;\n  --formField-padding-y: 0.3em;\n  --formField-padding-x: 0.9em;\n  --formField-background-color: white;\n  --formField-transition-duration: var(--default-transition-duration);\n  --formField-transition-timing: ease;\n\n  --formField-label-font-family: inherit;\n  --formField-label-font-weight: inherit;\n  --formField-label-color: var(--color-yellow-1);\n  --formField-label-ems: 1.1;\n\n  --formField-placeholder-color: var(--color-grey-5);\n\n  --formField-input-height: 1.4em;\n  --formField-input-font-family: inherit;\n  --formField-input-font-size: 1em;\n  --formField-input-font-weight: inherit;\n  --formField-input-color: black;\n  --formField-input-trigger-padding-right: 1.2em;\n\n  --formField-focus-outline: var(--default-focus-outline);\n  --formField-focus-outline-offset-to: 2px;\n  --formField-focus-outline-offset-from: 8px;\n\n  --formField-invalid-border-color: var(--color-red-2);\n  --formField-invalid-label-color: var(--color-red-2);\n\n  --formField-tooltip-box-shadow: var(--shadow-2);\n  --formField-errormessage-color: white;\n  --formField-errormessage-background-color: var(--color-red-2);\n  --formField-errormessage-border-color: white;\n\n  --formField-helpmessage-color: var(--color-grey-3);\n  --formField-helpmessage-font-size: 0.9em;\n\n  --formField-select-trigger-content: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--! Font Awesome Pro 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc. --><path d=\"M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z\"/></svg>');\n  --formField-select-trigger-padding: 0.25em 0 0 0;\n}\n\n/* Modal */\n.wildidea {\n  --modal-sm-margin-top: 15vh;\n  --modal-md-margin-top: 10vh;\n  --modal-lg-margin-top: 6vh;\n  --modal-margin-bottom: 10vh;\n  --modal-backdrop-background: rgba(0, 0, 0, 0.3);\n  --modal-backdrop-transition-duration: var(--default-transition-duration);\n  --modal-backdrop-transition-timing: var(--default-transition-timing);\n  --modal-backdrop-filter: blur(3px);\n  --modal-header-font-family: var(--subheading-font);\n  --modal-header-font-size: 1.2em;\n  --modal-header-font-weight: normal;\n  --modal-header-padding: 1.3em;\n  --modal-header-gap: 1.3em;\n  --modal-touch-action: pan-x pan-y;\n\n  @media (--screen-sm) {\n    --modal-header-font-size: 1.2em;\n  }\n}\n\n/* Pill */\n.wildidea {\n  --pill-font-size: 0.75em;\n  --pill-font-weight: 500;\n  --pill-border-radius: 8px;\n  --pill-padding: 0.25em 0.5em;\n  --pill-children-space-between: 0.4em;\n\n  --pill-paper1-background: var(--color-paper-1);\n  --pill-paper1-color: var(--color-paper-text);\n  --pill-paper2-background: var(--color-paper-2);\n  --pill-paper2-color: var(--color-paper-text);\n  --pill-inverse-background: var(--color-inverse);\n  --pill-inverse-color: var(--color-inverse-text);\n  --pill-info-background: var(--color-blue-1);\n  --pill-info-color: white;\n  --pill-success-background: var(--color-green-1);\n  --pill-success-color: white;\n  --pill-warn-background: var(--color-yellow-1);\n  --pill-warn-color: black;\n  --pill-error-background: var(--color-red-2);\n  --pill-error-color: white;\n}\n\n/* RadioInput */\n.wildidea {\n  --radio-input-invalid-focus-outline-color: var(--color-red-2);\n}\n\n/* Small */\n.wildidea {\n  --small-font-size: 0.9em;\n  --small-font-weight: lighter;\n  --small-text-decoration: line-through;\n  --small-color: var(--color-grey-3);\n}\n\n/* Strong */\n.wildidea {\n  --strong-font-size: 1.2em;\n  --strong-font-weight: bold;\n  --strong-font-style: italic;\n  --strong-font-variant: small-caps;\n  --strong-font-family: var(--logo-font);\n  --strong-text-decoration: underline;\n  --strong-text-underline-offset: 0.1em;\n  --strong-color: var(--color-blue-1);\n}\n\n/* SubmitButton */\n.wildidea {\n  --submit-button-animation-duration-ms: 1000;\n}\n\n/* Toaster */\n.wildidea {\n  --toaster-left: 0;\n  --toaster-right: 0;\n  --toaster-margin-x: auto;\n  --toaster-margin-bottom: 1rem;\n\n  --toast-margin-y: 0;\n  --toast-width: 30em;\n  --toast-max-width: calc(100% - 2em);\n  --toast-font-size: 1em;\n  --toast-dismiss-button-font-size: 0.9em;\n\n  --toast-progress-height: 0.2em;\n  --toast-progress-value-background: white;\n\n  @media (--screen-sm) {\n    --toaster-right: auto;\n    --toaster-margin-x: 2em;\n  }\n}\n\n/* Tooltip */\n.wildidea {\n  --tooltip-border-size: 2px;\n  --tooltip-border-radius: 4px;\n  --tooltip-transition-duration: var(--default-transition-duration);\n  --tooltip-transition-timing: ease;\n  --tooltip-min-width: 6em;\n  --tooltip-max-width: 100vw;\n  --tooltip-padding: 0.6em 1em;\n\n  --tooltip-trigger-offset: 0.5em;\n  --tooltip-arrow-size: 7px;\n\n  --tooltip-paper1-background: var(--color-paper-1);\n  --tooltip-paper1-color: var(--color-paper-text);\n\n  --tooltip-paper2-background: var(--color-paper-2);\n  --tooltip-paper2-color: var(--color-paper-text);\n\n  --tooltip-inverse-background: var(--color-inverse);\n  --tooltip-inverse-color: var(--color-inverse-text);\n\n  --tooltip-info-background: var(--gradient-blue-1);\n  --tooltip-info-color: white;\n\n  --tooltip-accent-background: var(--gradient-purple-1);\n  --tooltip-accent-color: white;\n\n  --tooltip-success-background: var(--color-green-1);\n  --tooltip-success-color: white;\n\n  --tooltip-warn-background: var(--color-yellow-1);\n  --tooltip-warn-color: black;\n\n  --tooltip-error-background: var(--gradient-red-1);\n  --tooltip-error-color: white;\n\n  --tooltip-box-shadow: var(--shadow-2);\n  --tooltip-elevated-box-shadow: var(--shadow-3);\n}\n\n/* Typeahead */\n.wildidea {\n  --typeahead-menu-listitem-highlighted-background: var(--color-grey-5);\n  --typeahead-menu-border: var(--color-grey-4);\n  --typeahead-menu-listitem-border-top: var(--color-grey-4);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
